import config from 'constants/config'
import { getShouldShowLuxPlusBeforeCharterFeederFlights } from 'checkout/selectors/navigationSelectors'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'

interface FlightLuxPlusPricingOptions {
  enabled?: boolean
  isBundledFlow?: boolean
}

// Declined Lux Plus Upsell should only apply if the upsell was shown in a charter feeder flow
export function shouldApplyDeclinedLuxPlusUpsell(
  state: App.State,
  isBundledFlow?: boolean,
): boolean {
  return !!isBundledFlow &&
    state.checkout.cart.luxPlusUpsellDecision === 'declined' &&
    getShouldShowLuxPlusBeforeCharterFeederFlights(state)
}

export function canRequestFlightLuxPlusPricing(state: App.State, options: FlightLuxPlusPricingOptions): boolean {
  const { enabled, isBundledFlow } = options
  if (!enabled || !getIsLuxPlusEnabled(state)) {
    return false
  }

  if (shouldApplyDeclinedLuxPlusUpsell(state, isBundledFlow)) {
    return false
  }

  return true
}

export function getFlightSearchIsLuxPlusParam(
  requestLuxPlusPricing: boolean,
  applyDeclinedLuxPlusUpsell: boolean,
): boolean | undefined {
  if (requestLuxPlusPricing) {
    return true
  }

  if (applyDeclinedLuxPlusUpsell) {
    return false
  }

  // svc-flights reads a missing value as "no explicit choice" and lets LP_PRICES enable member pricing.
  if (!config.LUXURY_PLUS_ENABLED) {
    return false
  }

  return undefined
}
